import BaseService from "./BaseService";

export default class CreditosService extends BaseService {

  constructor(self) {
    super(self);
  }

  ListarCreditos(parameters) {
    return this.ExecutaFetch("/api/Creditos/ListarCreditos", "POST", parameters);
  }
}